import { Component, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
import { ValidationService } from '../../shared/services/validation.service';
import { Utility } from '../../common/utility';
import { RegisterModel } from '../../models/register/register.model';
import { DialogService } from '../../shared/services/dialog.service';
import { RegisterService } from './register.service';
import { AppMessages } from '../../shared/constants/messages';
import { AuthService } from '../../shared/services/auth.service';
import { BaseUrl } from '../../shared/urls/base.url';
import { UserUrl } from '../../shared/urls/user.url';

@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html',
  providers: [RegisterService]
})
export class RegisterComponent implements OnInit {

  @ViewChild('formDir') ngForm;
  public registerForm:FormGroup;
  public registerModel = new RegisterModel();

  public countryData = [];
  public titleData = [];
  public collegeData = [];
  public sexData = [];
  public countryofbirthData = [];
  public healthinsuranceData = [];
  public partyTypes = [];
  public enumPartyType: any;
  public partyData = [];
  public billingcountryData = [];
  public marketingData = [];
  public occupationData = [];
  public isEdit = false;
  public occupationStudent: any;
  public isSeparate = false;
  //public valid: any;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute, private authService: AuthService,
    private formBuilder: FormBuilder,
    public utility: Utility,
    public registerService: RegisterService,
    public dialogService: DialogService
  ) {
    this.createForm();
  }

  ngOnInit() {
    if (!this.isEdit) {
      this.registerModel.patientREF = 'N/A';
    }
    this.getCountryData();
    this.getInitData();
    this.getPartyData();

    const dateOfBirth = this.utility.convertDateToString(this.registerForm.controls['birthDay'].value);
    this.registerForm.controls['dateOfBirth'].setValue(dateOfBirth);
    this.sexData = this.registerService.getSexData();
    this.enumPartyType = this.registerService.getTypeParty();
    this.activeRouter.paramMap.subscribe(params => {
      this.registerForm.controls['centreCode'].setValue(params.get("centreCode"));
    });
    //console.log('partyTypes', this.partyTypes);
    //this.registerModel.partyTypeId = this.partyTypes.find(x => x.id === this.enumPartyType).id;
  }

  createForm() {
    const dateOfBirth = new Date("1999-01-01");
      this.registerForm = this.formBuilder.group({
          firstName: ['', [Validators.required]],
          middleName: [''],
          surName: ['', [Validators.required]],
          titleId: [null, [Validators.required]],
          sexId: [null, [Validators.required]],
          birthDay: [dateOfBirth, [Validators.required, ValidationService.isValidDateOfBirth]],
          address1: ['', [Validators.required]],
          address2: ['', [Validators.required]],
          address3: [''],
          countryId: [null, [Validators.required]],
          countryOfBirthId: [null, [Validators.required]],
          email: ['', [Validators.required, ValidationService.isValidEmail]],
          occupationId : [null, [Validators.required]],
          reference: [''],
          patientREF: [''],
          postCode: [''],
          isIncludeInMarketing: [false],
          isSeparateBillingAddress: [false],
          billingAddress1: [''],
          billingAddress2: [''],
          billingAddress3: [''],
          billingCountryId: [null],
          billingPostCode: [''],
          homePhone: [''],
          workPhone: [''],
          mobilePhone: [''],
          healthPolicyNumber: [''],
          studentId: [''],
          healthInsuranceId:[null],
          college: [null],
          partyTypeId: [null],
          partyId: [''],
          billCountry: [''],
          marketingId: [null],
          callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL,
          dateOfBirth: [''],
          passportOrIdNumber: [''],
          centreCode: [''],
      });
  }

  getCountryData() {
    this.registerService.getCountryList().subscribe(
      (result) => {
        if(result){
          const data = result.json();
          this.countryData = data;

          // By default select Ireland
          const defaultCountryId = this.countryData.find(c => c.name === 'IRELAND');
          // localStorage.getItem(AppConstants.localStorage.countryId);
          if (defaultCountryId) {
              this.registerForm.controls['countryOfBirthId'].setValue(defaultCountryId['id']);
              this.registerForm.controls['countryId'].setValue(defaultCountryId['id']);
          }
        }
      }
    )
  }

  getInitData() {
    this.registerService.getInit().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.collegeData = data['colleges'];
          this.occupationData = data['occupations']
          this.healthinsuranceData = data['healthInsurances'];
          this.partyTypes = data['partyTypes'];
          this.titleData = data['titles'];
          this.marketingData = data['marketings'];
          const studentId = this.occupationData.find(o => o.name === 'Student');
          this.occupationStudent = studentId['id'];
        }
      }
    )
  }

  partyTypeChange() {
        if (this.registerModel.partyTypeId === '1') {
            ValidationService.attachRequired(this.registerForm.controls['partyId'], []);
        } else {
            ValidationService.removeRequired(this.registerForm.controls['partyId'], []);
        }
  }

  getPartyData() {
    this.registerService.getParty().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.partyData = data['list'];
        }
      }
    );
  }


  public login() {
    this.router.navigate(["/login"]);
  }

  inputMaxLength() {
    return 50;
  }

  inputMaxLengthPhone() {
    return 24;
  }

  addSeparateBillingAddress(e) {
        if (this.registerForm.controls['billingAddress1'].value === '') {
            this.registerForm.controls['billingAddress1'].
                setValue(this.registerForm.controls['address1'].value);
        }
        if (this.registerForm.controls['billingAddress2'].value === '') {
            this.registerForm.controls['billingAddress2'].
                setValue(this.registerForm.controls['address2'].value);
        }
        if (this.registerForm.controls['billingAddress3'].value === '') {
            this.registerForm.controls['billingAddress3'].
                setValue(this.registerForm.controls['address3'].value);
        }
        if (this.registerForm.controls['billingPostCode'].value === '') {
            this.registerForm.controls['billingPostCode'].
                setValue(this.registerForm.controls['postCode'].value);
        }
        if (this.registerForm.controls['billingCountryId'].value === '') {
            this.registerForm.controls['billingCountryId'].
                setValue(this.registerForm.controls['countryId'].value);
        }
    }

onDobChange(e) {
    ValidationService.validationDate(this.registerForm.controls['birthDay'], e);
    const dateOfBirth = this.utility.convertDateToString(this.registerForm.controls['birthDay'].value);
    this.registerForm.controls['dateOfBirth'].setValue(dateOfBirth);
}

onDobInput(e) {
  // ValidationService.validationDate(this.patientInformationForm.controls['dateOfBirth'], e);
}


  onSubmit() {
    this.registerForm.controls['partyTypeId'].setValue(this.partyTypes.find(x => x.name === 'Individual').id);
    // console.log('partytype',this.registerForm.controls['partyTypeId'].value);
      if (this.registerForm.valid)
      {
        this.registerService.addAccount(this.registerForm.value).subscribe(

          (result) => {
            if(result){
              const data = result.json();
              this.dialogService.openSuccessDialog({message: data.message});
            }
          }
        );
      }
  }



}






// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/register/register.component.ts